export default __webpack_public_path__ + "file-asset/bc2c2fc3c390fe5963ae6e18da131ac0-pen.svg";